import Logger from "../../../core/internal/logger"
import { InAppMessagePresentRequest } from "./InAppMessagePresentRequest"
import { InAppMessagePresentResponse } from "./InAppMessagePresentResponse"
import { InAppMessageRecorder } from "./record/InAppMessageRecorder"
import { InAppMessagePresenter } from "./presentation/InAppMessagePresenter"
import { InAppMessagePresentationContext } from "./presentation/InAppMessagePresentationContext"

export class InAppMessagePresentProcessor {
  constructor(private readonly presenter: InAppMessagePresenter, private readonly recorder: InAppMessageRecorder) {}

  async process(request: InAppMessagePresentRequest): Promise<InAppMessagePresentResponse> {
    Logger.log.debug(`InAppMessage Present Request: ${request}`)

    const response = await this.present(request)
    this.recorder.record(request, response)

    Logger.log.debug(`InAppMessage Present Response: ${response}`)
    return response
  }

  private present(request: InAppMessagePresentRequest): Promise<InAppMessagePresentResponse> {
    const context = InAppMessagePresentationContext.of(request)
    return this.presenter.present(context)
  }
}
